import { StandardMonthlyFeatureList } from './standardMonthlyFeatureList';
import { formatSummaryFeature } from '~pricing/lib/PackageFeatures';
import { SummaryFeatureList, SummaryFeatureRuleMap } from '../types';

const FlexFeatureList: SummaryFeatureList = StandardMonthlyFeatureList;

const FlexFeatureOverrideRules: SummaryFeatureRuleMap = {
  // Add feature rule overrides below
  support: () => formatSummaryFeature('email_support'),
  statistical_significance: () => formatSummaryFeature('text_analysis'),
};

export { FlexFeatureList, FlexFeatureOverrideRules };
